(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../_util/vantEvent", "@popperjs/core"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../_util/vantEvent"), require("@popperjs/core"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.vantEvent, global.core);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _vantEvent, _core) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-popover-s-wrap"
      }, [_c('transition', {
        attrs: {
          "name": "nx-popover-s"
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.showPopper,
          expression: "showPopper"
        }],
        ref: "popperS",
        staticClass: "nx-popover-s",
        class: {
          whiteFillColor: _vm.comType === 'white'
        },
        style: {
          transformOrigin: _vm.transformOrigin
        }
      }, [_vm.$slots.content ? [_vm._t("content")] : _c('span', {
        staticClass: "nx-popover-s__body",
        class: {
          whiteColor: _vm.comType === 'white'
        },
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      }), _vm.extra ? _c('div', {
        staticClass: "nx-popover-s__extra"
      }, [_c('img', {
        attrs: {
          "src": _vm.comType === 'white' ? 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/919e94f0-254e-11ee-8af8-0311b199d914.png' : 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/1774b1f0-0e6a-11ee-8af8-0311b199d914.png',
          "aria-label": "关闭",
          "role": "button"
        },
        on: {
          "click": _vm.$_click
        }
      })]) : _vm._e(), _c('span', {
        ref: "popoverArrow",
        staticClass: "nx-popover-s-arrow",
        class: {
          whiteFillColor: _vm.comType === 'white'
        },
        attrs: {
          "data-popper-arrow": ""
        }
      })], 2)]), _vm._t("default")], 2);
    },
    name: 'nx-popover-s',
    props: {
      value: {
        type: Boolean
      },
      trigger: {
        type: String,
        default: 'click',
        validator: function validator(value) {
          return ['click', 'manual'].indexOf(value) > -1;
        }
      },
      content: {
        type: String,
        default: ''
      },
      placement: {
        type: String,
        default: 'bottom'
      },
      offset: {
        type: Number,
        default: 0
      },
      extra: {
        type: String,
        default: '关闭'
      },
      delay: {
        type: Number,
        default: 3000
      },
      autoClose: {
        type: Boolean,
        default: false
      },
      autoResize: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'black'
      },
      boundary: {}
    },
    data: function data() {
      return {
        showPopper: false,
        popoverLeft: '0px',
        popoverHeight: 0,
        obs: undefined
      };
    },
    computed: {
      transformOrigin: function transformOrigin() {
        var _this$popperJS, _this$popperJS$state;

        var htmlFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        var computeWidth = parseInt(this.popoverLeft.replace('px', '')) + 0.15 * htmlFontSize;
        var arrowWidth = 0.22 * htmlFontSize;
        var originMap = {
          top: "".concat(computeWidth, "px ").concat(this.popoverHeight + arrowWidth, "px"),
          bottom: "".concat(computeWidth, "px  -").concat(arrowWidth, "px")
        };
        return originMap[((_this$popperJS = this.popperJS) === null || _this$popperJS === void 0 ? void 0 : (_this$popperJS$state = _this$popperJS.state) === null || _this$popperJS$state === void 0 ? void 0 : _this$popperJS$state.placement) || this.placement] || '';
      },
      comType: function comType() {
        var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';

        if (!nxThemeOff && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          return 'black';
        } else {
          return this.type;
        }
      }
    },
    watch: {
      value: {
        handler: function handler(val) {
          this.showPopper = val;
        }
      },
      showPopper: function showPopper(val) {
        var _this = this;

        if (val) {
          this.$emit('show');
          this.updatePopper();

          if (this.autoClose) {
            this.doAutoClose();
          }

          this.$nextTick(function () {
            var _this$$refs$popoverAr, _this$$refs$popoverAr2, _this$$refs$popperS;

            _this.popoverLeft = ((_this$$refs$popoverAr = _this.$refs.popoverArrow) === null || _this$$refs$popoverAr === void 0 ? void 0 : (_this$$refs$popoverAr2 = _this$$refs$popoverAr.style) === null || _this$$refs$popoverAr2 === void 0 ? void 0 : _this$$refs$popoverAr2.left) || '0px';
            _this.popoverHeight = (_this$$refs$popperS = _this.$refs.popperS) === null || _this$$refs$popperS === void 0 ? void 0 : _this$$refs$popperS.clientHeight;
          });
        } else {
          this.$emit('hide');
        }

        this.$emit('input', val);
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      var reference = this.referenceElm = this.$slots.default[0].elm;
      var popper = this.popper = this.$refs.popperS;
      this.$nextTick(function () {
        _this2.value && (_this2.showPopper = _this2.value);
      });
      if (!reference || !popper) return;

      if (this.trigger === 'click') {
        (0, _vantEvent.on)(reference, 'click', this.doToggle);
        (0, _vantEvent.on)(document, 'click', this.handleDocumentClick);
      }

      if (window.MutationObserver && this.autoResize) {
        this.$nextTick(function () {
          _this2.obs = new MutationObserver(function () {
            _this2.showPopper && _this2.updatePopper();
          });

          _this2.obs.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
    },
    methods: {
      updatePopper: function updatePopper() {
        var popperJS = this.popperJS;

        if (popperJS) {
          popperJS.update();
        } else {
          this.createPopper();
        }
      },
      createPopper: function createPopper() {
        if (!/^(top|bottom)?$/g.test(this.placement)) return;

        if (this.popperJS && this.popperJS.destroy) {
          this.popperJS.destroy();
        } // maxSize modifier


        var applyMaxSize = {
          name: 'applyMaxSize',
          enabled: true,
          phase: 'beforeWrite',
          fn: function fn(_ref) {
            var state = _ref.state;
            // 设置最大宽度
            state.styles.popper = _objectSpread(_objectSpread({}, state.styles.popper), {}, {
              maxWidth: "".concat(window.screen.width - 40, "px")
            });
          }
        };
        this.popperJS = (0, _core.createPopper)(this.referenceElm, this.popper, {
          placement: this.placement,
          modifiers: [applyMaxSize, {
            name: 'arrow',
            options: {
              padding: 12 // 让箭头不出现在圆角区域

            }
          }, {
            name: 'offset',
            options: {
              offset: [this.offset, 8]
            }
          }, {
            name: 'computeStyles',
            options: {
              gpuAcceleration: false // true by default

            }
          }, {
            name: 'preventOverflow',
            options: {
              priority: ['right'],
              padding: {
                top: 0,
                bottom: 0,
                left: 0.6 * parseFloat(getComputedStyle(document.documentElement).fontSize),
                right: 0.6 * parseFloat(getComputedStyle(document.documentElement).fontSize)
              }
            }
          }]
        });
        this.$nextTick(this.popperJS.update);
      },
      doToggle: function doToggle() {
        this.showPopper = !this.showPopper;
      },
      handleDocumentClick: function handleDocumentClick(e) {
        if (!this.$el || !this.referenceElm || this.elementContains(this.$el, e.target) || this.elementContains(this.referenceElm, e.target) || !this.popper || this.elementContains(this.popper, e.target)) {
          return;
        }

        this.showPopper = false;
      },
      elementContains: function elementContains(elm, otherElm) {
        if (typeof elm.contains === 'function') {
          return elm.contains(otherElm);
        }

        return false;
      },
      $_click: function $_click() {
        this.$emit('click');
        this.showPopper = false;
      },
      doAutoClose: function doAutoClose() {
        var _this3 = this;

        setTimeout(function () {
          _this3.showPopper = false;
        }, this.delay);
      },
      destroyPopper: function destroyPopper() {
        (0, _vantEvent.off)(this.referenceElm, 'click', this.doToggle);
        (0, _vantEvent.off)(document, 'click', this.handleDocumentClick);
        this.showPopper = false;

        if (this.popperJS) {
          this.popperJS.destroy();
          this.popperJS = null;
        }
      }
    },
    destroyed: function destroyed() {
      this.destroyPopper();

      if (window.MutationObserver && this.autoResize && this.obs) {
        this.obs.disconnect();
      }
    }
  };
  _exports.default = _default;
});